/* ========================================================================= */
/* User Agent */
/* ========================================================================= */

/** @type {import("$types/utilities/utilities").UserAgent} */
let USER_AGENT = {};

/**
 * Set global variable USER_AGENT
 * @param {import("$types/utilities/utilities").UserAgent} ua Browser's user agent
 */
export const setUserAgent = (ua) => {
    USER_AGENT = ua;
};

/**
 * Get global variable USER_AGENT
 * @return {import("$types/utilities/utilities").UserAgent}
 */
export default () => {
    return USER_AGENT;
};
